import { CREATE_SKETCH, DELETE_SKETCH, CLEAR_SKETCH, OPEN_SKETCH_MODAL, CLOSE_SKETCH_MODAL } from '../types'

export const createSketch = (trimmedDataURL) => {
  return {
    type: CREATE_SKETCH,
    payload: trimmedDataURL,
  }
}

export const deleteSketch = (trimmedDataURL) => {
  return {
    type: DELETE_SKETCH,
    payload: trimmedDataURL,
  }
}

export const clearSketch = () => {
  return {
    type: CLEAR_SKETCH,
  }
}

export const openSketchModal = () => {
  return {
    type: OPEN_SKETCH_MODAL,
  }
}

export const closeSketchModal = () => {
  return {
    type: CLOSE_SKETCH_MODAL,
  }
}
